"use strict";
/**
 * Created by Ning Jiang on 8/23/2017.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSprites = void 0;
const TimelineSprite_1 = require("@nolimitcity/slot-launcher/bin/animation/TimelineSprite");
const gsap_1 = require("gsap");
class MultiSprites extends PIXI.Container {
    get currentSprite() {
        return this._currentSprite;
    }
    get currentSpriteName() {
        return this._currentSpriteName;
    }
    constructor() {
        super();
        this.sprites = {};
    }
    addSprites(...config) {
        config.forEach(c => {
            const animation = new TimelineSprite_1.TimelineSprite(c.textures, c.fps ? c.fps : 30);
            if (c.anchor) {
                animation.anchor.set(c.anchor.x, c.anchor.y);
            }
            animation.visible = false;
            this.sprites[c.name] = animation;
            this.addChild(animation);
        });
    }
    // prop is for tweening on the image's prop, such as tweening the x of image.scale.
    playSprite(name, tweenInConfig, tweenOutConfig, frames) {
        return this.playSpriteFromTo(name, {}, tweenInConfig, tweenOutConfig, frames);
    }
    // prop is for tweening on the image's prop, such as tweening the x of image.scale.
    playSpriteFromTo(name, tweenInFrom, tweenInTo, tweenOut, frames) {
        var _a, _b, _c, _d;
        const newSprite = this.sprites[name];
        const oldSprite = this._currentSprite;
        // we don't use fromTo cos it messes up with chain animations.
        tweenInFrom.duration = 0.001;
        const tl = (_a = gsap_1.gsap.timeline) === null || _a === void 0 ? void 0 : _a.call(gsap_1.gsap);
        tl.add(() => {
            newSprite.visible = true;
            this._currentSpriteName = name;
            this._currentSprite = newSprite;
        });
        tl.add((_b = gsap_1.gsap.to) === null || _b === void 0 ? void 0 : _b.call(gsap_1.gsap, newSprite, tweenInFrom));
        tl.add([
            (_c = gsap_1.gsap.to) === null || _c === void 0 ? void 0 : _c.call(gsap_1.gsap, newSprite, tweenInTo),
            newSprite.getAnimation(frames)
        ]);
        if (oldSprite && oldSprite != newSprite) {
            tl.add((_d = gsap_1.gsap.to) === null || _d === void 0 ? void 0 : _d.call(gsap_1.gsap, oldSprite, tweenOut), 0);
            tl.add(() => { oldSprite.visible = false; });
        }
        return tl;
    }
}
exports.MultiSprites = MultiSprites;
//# sourceMappingURL=MultiSprites.js.map